import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getEquipmentPledges: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGES,
	},
	getEquipmentPledge: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGE,
	},
	createEquipmentPledge: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].CREATE_EQUIPMENT_PLEDGE,
	},
	patchEquipmentPledge: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PATCH_EQUIPMENT_PLEDGE,
	},
	putEquipmentPledge: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PUT_EQUIPMENT_PLEDGE,
	},
	deleteEquipmentPledge: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].DELETE_EQUIPMENT_PLEDGE,
	},
}
